import { StyleguideComponentProps } from 'lib/component-props';
import React, { JSX } from 'react';

type ContentSeparatorProps = StyleguideComponentProps & {
  fields: {
    BaseBlankSpace: {
      value: boolean;
    };
  };
};

const ContentSeparator = (props: ContentSeparatorProps): JSX.Element => {
  const { fields } = props;

  return (
    <div
      className="overhauled"
      id={`content-separator-${props.rendering?.uid}`}
    >
      <div className="jss-inner-container">
        <div
          className={
            fields?.BaseBlankSpace?.value ? 'separator-blank' : 'separator'
          }
        ></div>
      </div>
    </div>
  );
};

export default ContentSeparator;
